import React, { useState } from 'react';
import { Box, Grid, Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { styled } from '@mui/system';
import Modal from '@mui/material/Modal';
import TokenSuccess from '@assets/images/tokensuccess.svg';
import Tokenfailed from '@assets/images/tokenfailed.svg';
import {tokenService} from "@services/token.service";
import DownloadingIcon from '@mui/icons-material/Downloading';
import {useHistory} from "react-router-dom";

const ModalContainer = styled('div')(({ theme }) => ({

    [theme.breakpoints.up("sm")]: {
        width: 300,
    },
    [theme.breakpoints.down("md")]: {
        width: '70%'
    },

    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    boxShadow: '24',
    borderRadius: '10px',
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    padding: '20px 55px 40px 55px'
}));

export default function ImportTokenDialog({ open, onClose, tokenAddress, id, chainId }: { open: boolean, onClose: Function, tokenAddress: string, id: string, chainId: number }) {
    const [importTokenScreen, setImportTokenScreen] = useState(true)
    const [importLoadingScreen, setImportLoadingScreen] = useState(false)
    const [importSuccessScreen, setImportSuccessScreen] = useState(false)
    const [importFailedScreen, setImportFailedScreen] = useState(false)
    const [tokenId, setTokenId] = useState(-1)
    const [errorMessage, setErrorMessage] = useState('')
    const history = useHistory();

    const handleScreen = (status: string, message: string = '') => {
        setImportTokenScreen(false);
        if (status === 'loading') {
            setImportLoadingScreen(true);
            setImportSuccessScreen(false);
            setImportFailedScreen(false);
        }
        else if (status === 'success') {
            setImportLoadingScreen(false);
            setImportSuccessScreen(true);
            setImportFailedScreen(false);
        } else {
            setErrorMessage(message);
            setImportLoadingScreen(false);
            setImportSuccessScreen(false);
            setImportFailedScreen(true);
        }
    }

    const viewToken = () => {
        history.push(`/tokens/${tokenId}?owned=true`)
    }

    const importToken = async () => {
        handleScreen('loading');
        let response:any = await tokenService.importToken(id, tokenAddress, chainId);
        // console.log(response)

        if(response.data.owned && !response.data.duplicate) {
            setTokenId(response.data.id)
            handleScreen('success');
        } else {
            handleScreen('error', response.data.message);
        }
    }

    const resetImport = () => {
        setErrorMessage('');
        setTokenId(-1);
        setImportTokenScreen(true);
        setImportLoadingScreen(false);
        setImportSuccessScreen(false);
        setImportFailedScreen(false);
        onClose();
    }

    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <>
                <ModalContainer>
                    {importTokenScreen && (
                        <>
                            <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>{"We'll be checking your wallet(s) for a token at this contract address:"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description" >

                                    <a href="" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                        <Typography fontWeight={400} color={'#94A3B8'}>
                                           {tokenAddress}
                                        </Typography>
                                    </a>
                                </DialogContentText>
                            </DialogContent>
                            <Grid container>
                                <Grid item xs={12} md={12}>
                                    <Box mb={2}>
                                        {/*<Button variant="contained" className={'button w-100'} color="primary" onClick={() => handleScreen("success")}>*/}
                                        <Button variant="contained" className={'button w-100'} color="primary" onClick={() => importToken()}>
                                            <Typography fontWeight={700} className={'button-label'}>
                                                Continue
                                            </Typography>
                                        </Button>
                                    </Box>

                                    <Box>
                                        <Button variant="outlined" className={'button w-100'} color="primary" onClick={() => onClose()} autoFocus>
                                            <Typography fontWeight={700} className={'button-label'}>
                                                Cancel
                                            </Typography>
                                        </Button>
                                    </Box >
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {importLoadingScreen && (
                        <>
                            <>
                                <Box>
                                    <DownloadingIcon></DownloadingIcon>
                                </Box>
                                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>{"Verifying ownership"}</DialogTitle>

                                {/*<Grid container>
                                    <Grid item xs={12} md={12}>
                                        <Box >
                                            <Button variant="contained" className={'button w-100'} color="primary" >
                                                <Typography fontWeight={700} className={'button-label'}>
                                                    View Token
                                                </Typography>
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>*/}
                                <Box mt={2}>
                                    <Typography
                                        className={'body2'}
                                    >
                                        We're verifying your token ownership on the blockchain. This should only take a minute...
                                    </Typography>
                                </Box>
                            </>
                        </>
                    )}

                    {importSuccessScreen && (
                        <>
                            <>
                                <Box>
                                    <img src={TokenSuccess} alt="Success Import Icon" />
                                </Box>
                                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>{"Token imported successfully!"}</DialogTitle>

                                <Grid container>
                                    <Grid item xs={12} md={12}>
                                        <Box mb={2}>
                                            <Button variant="contained" className={'button w-100'} color="primary" onClick={() => viewToken()} >
                                                <Typography fontWeight={700} className={'button-label'}>
                                                    View Token
                                                </Typography>
                                            </Button>
                                        </Box>
                                        <Box>
                                            <Button variant="outlined" className={'button w-100'} color="primary" onClick={() => resetImport()} autoFocus>
                                                <Typography fontWeight={700} className={'button-label'}>
                                                    Close
                                                </Typography>
                                            </Button>
                                        </Box >
                                    </Grid>
                                </Grid>
                            </>
                        </>
                    )}

                    {importFailedScreen && (
                        <>
                            <>
                                <Box>
                                    <img src={Tokenfailed} alt="Failed Import Icon" />
                                </Box>
                                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>{"Hmm... Something went wrong"}</DialogTitle>

                                <Grid container>
                                    <Grid item xs={12} md={12}>
                                        <Box mb={2}>
                                            <Typography
                                                className={'body2'}
                                            >
                                                {errorMessage}
                                            </Typography>
                                        </Box>
                                        {/*<Box mb={2}>
                                            <Button variant="contained" className={'button w-100'} color="primary" onClick={() => onClose()}>
                                                <Typography fontWeight={700} className={'button-label'}>
                                                    Try Again
                                                </Typography>
                                            </Button>
                                        </Box>*/}
                                        <Box>
                                            <Button variant="outlined" className={'button w-100'} color="primary" onClick={() => resetImport()} autoFocus>
                                                <Typography fontWeight={700} className={'button-label'}>
                                                    Close
                                                </Typography>
                                            </Button>
                                        </Box >
                                    </Grid>
                                </Grid>
                            </>
                        </>
                    )}

                </ModalContainer>
            </>
        </Modal>
    );
}
